import { render, staticRenderFns } from "./healingIfeelDetection.vue?vue&type=template&id=09edfd26&scoped=true&"
import script from "./healingIfeelDetection.vue?vue&type=script&lang=js&"
export * from "./healingIfeelDetection.vue?vue&type=script&lang=js&"
import style0 from "./healingIfeelDetection.vue?vue&type=style&index=0&id=09edfd26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09edfd26",
  null
  
)

export default component.exports